import { getBonusxApiConfigV2 } from "../../common/bonusxApiConfig";
import { IProductWithCmsDataAndQualificationDto } from "../../pages/ProductsListPage/dtos/product-with-cms-data-and-qualification/product-with-cms-data-and-qualification.dto.interface";
import { Mapper } from "../../utils/mapper";
import { ApiClientAbstract } from "../ApiClient/ApiClientAbstract";
import { IApiClientService } from "../ApiClient/ApiClientService.interface";
import AxiosApiClientInstance from "../AxiosApiClientInstance/AxiosApiClientInstance";
import { IApiClientBonusxProductsRepository } from "./ApiClientBonusxProductsRepository.interface";
import { ProductsApiResponseDto } from "./dtos/products-api-response/products-api-response.dto";
import { IProductsApiResponseDto } from "./dtos/products-api-response/products-api-response.dto.interface";

export class ApiClientBonusxProductsRepository extends ApiClientAbstract implements IApiClientBonusxProductsRepository {
  private readonly _PRODUCTS_URL = "/products";

  constructor(client: IApiClientService = new AxiosApiClientInstance(undefined, getBonusxApiConfigV2())) {
    super(client);
  }

  public async getAllProducts(): Promise<IProductWithCmsDataAndQualificationDto[]> {
    const response = await this.get<IProductsApiResponseDto>(this._PRODUCTS_URL);

    const responseData = response.data;
    if (!responseData) {
      throw this._genericException();
    }

    const responseDto = Mapper.mapData(ProductsApiResponseDto, responseData);

    const products = responseDto.services;
    return products;
  }
}
